import React, { useState } from "react"
import SideBarLayout from "../../../layout/side-bar-layout"
import { TITLE_DESIGN_SYSTEM_PAGE } from "../../../../utils/constants"
import { Box, Paper, Typography, Stack } from "@mui/material"
import CodeViewer from "../../../components/CodeViewer/code-viewer"
import DuplaConfirmacaoModal from "src/v2/components/DuplaConfirmacao/DuplaConfirmacao"
import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as EyeCloseIcon } from "src/v2/assets/icons/eye-close.svg"
import { ReactComponent as TrashIcon } from "src/v2/assets/icons/trash-icon.svg"
import {dispatchDuplaConfirmacao} from "../../../components/DuplaConfirmacao/DuplaConfirmacaoBus"

const DuplaConfirmacaoDesignSystemPage = () => {
    const [openBasic, setOpenBasic] = useState(false)
    const [openPublicar, setOpenPublicar] = useState(false)
    const [openEditarCetip, setOpenEditarCetip] = useState(false)
    const [openDeletar, setOpenDeletar] = useState(false)
    const TITLE_PAGE = `${TITLE_DESIGN_SYSTEM_PAGE} | Dupla Confirmação`

    const exemploListener = () => {
        dispatchDuplaConfirmacao({
            title: "Exemplo via listener",
            open: true,
            description: "Exemplo chamado utilizando o listener",
            confirmTextButton: "OK",
            confirmAction: () => alert("Teste do confirmar"),
            cancelAction: () => alert("Teste do cancelar"),
        })
    }

    const codeListener = `const exemploListener = () => {
    dispatchDuplaConfirmacao({
        title: "Exemplo via listener",
        open: true,
        description: "Exemplo chamado utilizando o listener",
        confirmTextButton: "OK",
        confirmAction: () => alert("Teste do confirmar"),
        cancelAction: () => alert("Teste do cancelar"),
        cancelIcon: <EyeCloseIcon />,
        confirmIcon: <EyeIcon />,
    })
 }`

    const codeBasicUsage = `
import DuplaConfirmacaoModal from "src/v2/components/DuplaConfirmacao/DuplaConfirmacao"

<DuplaConfirmacaoModal
    open={open}
    cancel={() => setOpen(false)}
    confirm={() => handleConfirm()}
    action="excluir"
/>
`

    const codePropsTable = `
type DuplaConfirmacaoProps = {
  open?: boolean
  cancel?: () => void
  confirm?: () => void
  action?: string
  description?: string
  title?: string
  confirmTextButton?: string
}
`

const codePublicar = `
<DuplaConfirmacaoModal
    open={open}
    cancel={handleCancel}
    confirm={handleConfirm}
    title="Publicar"
    description="Certifique-se de corrigir todos os campos antes de publicar um Documento."
    confirmTextButton="PUBLICAR"
/>
`

const codeCETIP = `
<DuplaConfirmacaoModal
    open={open}
    cancel={handleCancel}
    confirm={handleConfirm}
    title="Editar CETIP"
    description="Certifique-se de que todas as alterações necessárias foram feitas, já que este é um registro em produção."
/>
`

const codeDelete = `
<DuplaConfirmacaoModal
    open={open}
    cancel={handleCancel}
    confirm={handleConfirm}
    title="Deletar"
    description="Certifique-se que quer excluir todos os dados de características e garantias desse CETIP e Versão Documento."
    confirmTextButton="DELETAR"
    cancelIcon={ <EyeCloseIcon style={{ width: 22, height: 22, color: "#E3A404" }} /> }
    confirmIcon={ <TrashIcon style={{ width: 22, height: 22, color: "#E3A404" }} /> }
/>
`


    return (
        <SideBarLayout
            header
            title={TITLE_PAGE}
            headerTitle={TITLE_PAGE}
        >
            <Box sx={{ mt: -2 }}>
                <Stack spacing={3}>

                    {/* INTRODUÇÃO */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h4" gutterBottom color="common.white">
                                Dupla Confirmação
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                Componente modal utilizado em ações sensíveis que exigem dupla confirmação, como
                                excluir, publicar, duplicar, substituir ou atualizar.
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                Possui botões de cancelar, confirmar e um botão de fechar no canto superior direito.
                            </Typography>
                        </Box>
                    </Paper>

                    {/* EXEMPLO PRINCIPAL */}
                    <Paper>
                    <Box p={3}>
                        <Typography variant="h6" gutterBottom color="common.white">
                            Exemplo principal
                        </Typography>

                        <Typography variant="body2" color="text.secondary" paragraph>
                            Exemplo básico do uso do modal de dupla confirmação.
                        </Typography>

                        <ButtonWithIcon
                            onClick={() => setOpenBasic(true)}
                            label="Abrir exemplo básico"
                            primary
                        >Exemplo Padrão</ButtonWithIcon>

                        <DuplaConfirmacaoModal
                            open={openBasic}
                            cancel={() => setOpenBasic(false)}
                            confirm={() => {
                                console.log("Confirmado: exemplo básico")
                                setOpenBasic(false)
                            }}
                            action="excluir"
                        />
                    </Box>
                    </Paper>

                    {/* Utilizando o dispatch */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Exemplo utilizando o dispatch
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                Exemplo básico do uso do modal de dupla confirmação chamando diretamente o listener
                            </Typography>

                            <ButtonWithIcon
                                onClick={() => exemploListener()}
                                label="Abrir exemplo via listener"
                                primary
                            >Exemplo Listener</ButtonWithIcon>

                            <DuplaConfirmacaoModal
                                open={openBasic}
                                cancel={() => setOpenBasic(false)}
                                confirm={() => {
                                    console.log("Confirmado: exemplo básico")
                                    setOpenBasic(false)
                                }}
                                action="excluir"
                            />
                        </Box>
                    </Paper>

                    {/* EXEMPLO: PUBLICAR */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Exemplo — Publicar
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                Exemplo de uso do modal com <strong>título e descrição customizados</strong>.
                            </Typography>

                            <ButtonWithIcon
                                onClick={() => setOpenPublicar(true)}
                                label="Abrir modal Publicar"
                                primary
                            >Exemplo Publicar</ButtonWithIcon>

                            <DuplaConfirmacaoModal
                                open={openPublicar}
                                cancel={() => setOpenPublicar(false)}
                                confirm={() => {
                                    console.log("Confirmado: Publicar")
                                    setOpenPublicar(false)
                                }}
                                title="Publicar"
                                description="Certifique-se de corrigir todos os campos antes de publicar um Documento."
                                confirmTextButton="PUBLICAR"
                            />
                        </Box>
                    </Paper>

                    {/* EXEMPLO: EDITAR CETIP */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Exemplo — Editar CETIP
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                Exemplo usando <code>title</code> e <code>description</code> para substituir
                                completamente o conteúdo padrão.
                            </Typography>

                            <ButtonWithIcon
                                onClick={() => setOpenEditarCetip(true)}
                                label="Abrir modal Editar CETIP"
                                primary
                            >Exemplo CETIP</ButtonWithIcon>

                            <DuplaConfirmacaoModal
                                open={openEditarCetip}
                                cancel={() => setOpenEditarCetip(false)}
                                confirm={() => {
                                    console.log("Confirmado: Editar CETIP")
                                    setOpenEditarCetip(false)
                                }}
                                title="Editar CETIP"
                                description="Certifique-se de que todas as alterações necessárias foram feitas, já que este é um registro em produção."
                                action="editar"
                            />
                        </Box>
                    </Paper>

                    {/* EXEMPLO: DELETAR */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Exemplo — Deletar
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                Exemplo usando <code>title</code> e <code>description</code> para substituir
                                completamente o conteúdo padrão.
                            </Typography>

                            <ButtonWithIcon
                                onClick={() => setOpenDeletar(true)}
                                label="Abrir modal Deletar"
                                primary
                            >Exemplo Deletar</ButtonWithIcon>

                            <DuplaConfirmacaoModal
                                open={openDeletar}
                                cancel={() => setOpenDeletar(false)}
                                confirm={() => {
                                    console.log("Confirmado: Deletar")
                                    setOpenDeletar(false)
                                }}
                                title="Deletar"
                                description="Certifique-se que quer excluir todos os dados de características e garantias desse CETIP e Versão Documento."
                                confirmTextButton="DELETAR"
                                cancelIcon={<EyeCloseIcon style={{width: 22, height: 22, color: "#E3A404"}} />}
                                confirmIcon={<TrashIcon style={{width: 22, height: 22, color: "#E3A404"}}/>}
                            />
                        </Box>
                    </Paper>

                    {/* ESTRUTURA DO LAYOUT */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Estrutura do layout do componente
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                O <strong>DuplaConfirmacaoModal</strong> é construído sobre o componente Dialog do MUI,
                                com estilizações próprias para seguir o design system da aplicação. A estrutura possui
                                três partes principais:
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                <strong>• Header:</strong> apresenta o título “Dupla Confirmação” e um botão de fechar.
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                <strong>• Conteúdo:</strong> exibe a mensagem informativa conforme a ação passada pela
                                prop <code>action</code>.
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                <strong>• Rodapé:</strong> contém os botões CANCELAR e CONFIRMAR, seguindo o padrão visual
                                da aplicação.
                            </Typography>

                            <Typography variant="body2" color="text.secondary" paragraph>
                                As funções <code>cancel</code> e <code>confirm</code> permitem totalmente desacoplar o
                                componente da lógica de negócio, facilitando a reutilização.
                            </Typography>

                            <Typography variant="body2" color="text.secondary">
                                A prop <code>open</code> controla a abertura/fechamento, permitindo integração com
                                estados locais, Redux ou Context API.
                            </Typography>
                            <Typography variant="body2" color="text.secondary" paragraph> 
                                Também é possível substituir completamente o texto padrão passando a prop <code>description</code>. 
                                Isso permite reutilizar o modal em outros contextos, como o modal “Editar CETIP”. 
                            </Typography>
                        </Box>
                    </Paper>

                    {/* CÓDIGO DE EXEMPLO PADRÃO */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Código exemplo
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeBasicUsage} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    {/* CÓDIGO DE EXEMPLO LISTENER*/}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Código exemplo utilizando o listener
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeListener} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                     {/* CÓDIGO DE EXEMPLO PUBLICAR*/}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Código exemplo publicar
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codePublicar} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    {/* CÓDIGO DE EXEMPLO EDITAR CETIP*/}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Código exemplo editar CETIP
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeCETIP} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    {/* CÓDIGO DE EXEMPLO DELETAR  */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Código exemplo deletar
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codeDelete} language="jsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                    
                    {/* PROPRIEDADES */}
                    <Paper>
                        <Box p={3}>
                            <Typography variant="h6" gutterBottom color="common.white">
                                Propriedades do componente
                            </Typography>

                            <Paper variant="outlined">
                                <Box p={2}>
                                    <CodeViewer code={codePropsTable} language="tsx" />
                                </Box>
                            </Paper>
                        </Box>
                    </Paper>

                </Stack>
            </Box>
        </SideBarLayout>
    )
}

export default DuplaConfirmacaoDesignSystemPage
